import React from 'react'

function Footer() {
  return (
    <div className='footer'>
        copyright@2022
    </div>
  )
}

export default Footer